import { createRoute } from '@tanstack/react-router'
import DashboardPage from '@/features/dashboard/pages/DashboardPage'
import { Route as authenticatedRoute } from './route'

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/',
  component: DashboardPage,
})
